import { render, staticRenderFns } from "./kyc.vue?vue&type=template&id=5a638eb7&scoped=true&"
import script from "./kyc.vue?vue&type=script&lang=js&"
export * from "./kyc.vue?vue&type=script&lang=js&"
import style0 from "./kyc.vue?vue&type=style&index=0&id=5a638eb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a638eb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VContainer,VForm,VSelect})
